import React from 'react';

const pillars = [
  {
    num: '01',
    category: 'Venture Capital',
    title: 'Deep-Tech Moats & Architectural Defensibility',
    desc: 'Underwrite algorithmic defensibility and true technical architecture before term sheets. Frontier stress-tests software codebases, audits proprietary data moats, models synthetic unit economics, and aligns portfolio roadmaps for proactive strategic M&A exits.',
    image: 'https://images.unsplash.com/photo-1506146332389-18140dc7b2fb?q=80&w=1600&auto=format&fit=crop',
    tag: '48h Moat Audits',
  },
  {
    num: '02',
    category: 'Private Equity',
    title: 'High-Conviction Thesis Underwriting',
    desc: 'Underwrite non-consensus investment theses that survive beyond the closing dinner. Frontier eliminates conviction lag in thematic sourcing, stress-tests commercial moats and returns with adversarial IC rigor, and bridges diligence directly into value creation.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop',
    tag: 'Deterministic LBO Math',
  },
  {
    num: '03',
    category: 'Corporate Strategy & M&A',
    title: 'Always-On Strategic Intelligence',
    desc: 'Replace episodic consulting studies with an in-tenant, continuous deal horsepower desk. Frontier autonomously monitors global competitive disruption, evaluates multi-scenario build vs. buy and JV alternatives, and formulates post-close integration playbooks.',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=1600&auto=format&fit=crop',
    tag: 'Continuous M&A Engine',
  },
  {
    num: '04',
    category: 'Strategy & M&A Advisory',
    title: 'Decoupling Scale from Headcount',
    desc: 'Break the linear labor pyramid by turning 48-hour diligence into an unfair advisory advantage. Deliver audit-grade commercial due diligence decks and technical reviews that win competitive mandates and expand practice margins without analyst burnout.',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=1600&auto=format&fit=crop',
    tag: '10x CDD Velocity',
  },
  {
    num: '05',
    category: 'Investment Banking',
    title: 'Elevating Bankers to Strategic Consiglieres',
    desc: 'Free senior dealmakers from bullpen oversight to focus strictly on board-level advisory. Frontier automates contextual CIM generation, comp spreads, and strategic buyer universe mapping with cell-to-source provenance and zero data leakage.',
    image: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?q=80&w=1600&auto=format&fit=crop',
    tag: 'Zero-Leakage CIMs',
  },
];

// Section 3 — Practice lenses (5 pillars).
export const PracticesSection = () => (
  <section className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-b border-stone-200/80 bg-[#FBFBFB]">
    <div id="practices" className="scroll-mt-20 w-full max-w-[1600px] mx-auto">

      <div className="max-w-3xl mb-14 sm:mb-16">
        <span className="mono text-[10px] uppercase tracking-widest text-[#F58220] font-semibold block mb-2.5">Practice Lenses</span>
        <h2 className="text-3xl sm:text-5xl font-medium tracking-tight text-stone-950 mb-3.5">Every fund. Every mandate.</h2>
        <p className="text-base sm:text-lg text-stone-700 leading-relaxed font-sans max-w-2xl">
          Different balance sheets carry different priorities. Frontier is purpose-built to execute the exact underwriting stakes and strategic mandates of your firm.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {pillars.map((p) => (
          <div key={p.num} className="relative rounded-3xl overflow-hidden bg-[#090E1A] border border-white/10 min-h-[380px] flex flex-col justify-end p-7 group">
            <img src={p.image} alt={p.category} className="absolute inset-0 w-full h-full object-cover object-center opacity-45 group-hover:opacity-55 group-hover:scale-[1.03] transition-all duration-700 pointer-events-none" style={{ filter: 'contrast(1.15) brightness(0.85)' }} />
            <div className="absolute inset-0 bg-gradient-to-t from-[#090E1A] via-[#090E1A]/85 to-[#090E1A]/30 pointer-events-none" />
            <div className="relative z-10">
              <span className="text-xs font-mono font-bold text-[#F58220] mb-2 block uppercase tracking-wider">{p.num} // {p.category}</span>
              <h3 className="text-xl font-bold text-white mb-3 tracking-tight leading-snug">{p.title}</h3>
              <p className="text-[13px] text-white/60 leading-relaxed font-sans mb-4">{p.desc}</p>
              <span className="inline-block text-[11px] font-mono font-semibold text-white/80 bg-white/[0.06] border border-white/15 px-2.5 py-1 rounded-md">{p.tag}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
